import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import cx from 'classnames';
import { DateInfo } from 'govbr.frontend.policy/components';
import PropTypes from 'prop-types';

const DefaultTemplate = ({ items, linkTitle, linkHref, isEditMode }) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink
        to={flattenToAppURL(href)}
        condition={!isEditMode}
        className="br-item"
      >
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <UniversalLink href={href}>{linkTitle || href}</UniversalLink>;
  }

  return (
    <>
      <div>
        <ul className="listing-style-none pl-0">
          {items.map((item) => {
            const { '@id': url, id, title, description, review_state } = item;

            return (
              <li className="listing-style-none" key={item['@id']}>
                <ConditionalLink
                  item={item}
                  condition={!isEditMode}
                  className="br-item"
                  key={url}
                >
                  <div className="py-3 hover" key={url}>
                    <div
                      className={cx(
                        'text-up-02 text-weight-medium text-interactive',
                        { [`review-state-${review_state}`]: review_state },
                      )}
                    >
                      {title ? title : id}
                    </div>
                    <div className="mb-2 text-up-01 text-gray-80">
                      {description}
                    </div>
                    <DateInfo item={item} />
                  </div>
                </ConditionalLink>
              </li>
            );
          })}
        </ul>
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

DefaultTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default DefaultTemplate;
